import { render, staticRenderFns } from "./TestQuestion.vue?vue&type=template&id=abcc05c8&"
import script from "./TestQuestion.vue?vue&type=script&lang=js&"
export * from "./TestQuestion.vue?vue&type=script&lang=js&"
import style0 from "./TestQuestion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports